import {map, split, flow, last, includes, range, fullday, minutes, minutesToTime, moment, createSelector, createStructuredSelector} from 'helpers';
import {collaboration, editable} from 'store/relations';
import {images} from 'store/files/selectors';
import {readableCalendars} from 'store/google-calendar';
import {repetition} from './repetition';
import {saved} from 'store/server';
import {status} from './status';
import {activity, subroutinesById, subtasks} from './activities';
import {today, createdDate} from 'store/common';
import {type} from './type';
import {allDay} from './all-day';
import {times} from './times';
import {perDay} from './per-day';
import {byActivityId as diaryByActivityId} from 'store/diary';

export const timeframe = createSelector(
  [ activity, today ],
  ( activity = {}, today ) => {
    if (activity.ts) {
      const diff = moment.unix(activity.ts).diff(today, 'days');
      return diff < 0 ? 'past' : 'future';
    } else if (activity.endDate && activity.endDate < today.unix()) {
      return 'muted';
    }
  }
);

export const ritual = ({ dailyRoutineType } = {}) => {
  return dailyRoutineType == 'daily_routine';
}

export function dayParts({ time, dayParts = '' } = {}) {
  if (time && minutes(time) >= minutes('6:00 PM')) {
    return 'Evening';
  } else if (time) {
    return minutes(time) >= minutes('12:00 PM') ? 'Afternoon' : 'Morning';
  }
  return split(dayParts, ', ').shift();
}

const subroutines = createSelector(
  [ activity, subroutinesById ],
  ( activity, subroutinesById) => {
    let [ current = Infinity ] = times(activity).map(minutes);
    return map(subroutinesById[activity && activity.id], subroutine => {
      const time = current === Infinity ? null : minutesToTime(current);
      current += subroutine.duration ? subroutine.duration : Infinity;
      return { ...subroutine, time };
    });
  },
);

export const details = createStructuredSelector({
  activity,
  allDay: createSelector(activity, allDay),
  collaboration,
  createDate: createSelector(activity, flow(createdDate, moment.unix)),
  dayParts: createSelector(activity, dayParts),
  image: createSelector(images, images => last(images)),
  perDay: createSelector(activity, perDay),
  repetition: createSelector([ activity, repetition ], (activity, repetition) => repetition(activity)),
  ritual: createSelector(activity, ritual),
  saved,
  status: createSelector([ activity, today ], status),
  subroutines,
  subtasks,
  timeframe,
  times: createSelector(activity, times),
  type: createSelector(activity, type),
  diary: createSelector(
    [activity, diaryByActivityId],
    (activity, diaryByActivityId) => diaryByActivityId[activity?.id]
  ),
  editable: createSelector(
    [ activity, editable, readableCalendars ],
    ( activity, editable, readableCalendars ) => editable && !readableCalendars[activity && activity.googleCalendarId],
  )
});
